// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1R_C7","title":"AfterBackImages_title__yoYVg","images":"AfterBackImages_images__28g_Y"};